import Helpers from "@/lib/helpers";
import {setUser} from "@sentry/vue";
import * as Sentry from "@sentry/vue";
import store from "@/store/index";

const state = {
    remote_token: null,
    status: '',
    user: '',
    name: '',
    id: '',
    warehouse: {},
    previous_name: '',
    previous_user: '',
}

const getters = {
    isAuthenticated: state => state.status === 'success',
}

const actions = {
    async auth_warehouse({commit, dispatch}, data) {
        const warehouse = await helpers.asyncAction('/api/user/self/warehouse', 'PUT', {data: {warehouse: data}})
        commit('auth_warehouse', {warehouse})
    },
    async impersonate({commit, dispatch}, url) {
        const result = await Helpers.asyncAction(url, 'put')
        await commit('auth_success', result)

        // load any settings here that are authed
        await dispatch('settings_load')
    }
}
const mutations = {
    auth_warehouse(state, resp) {
        state.warehouse = resp.warehouse
    },

    auth_success(state, resp) {
        state.status = 'success'

        // null for the browser: its device token lives in an HttpOnly cookie now
        state.remote_token = resp.remote_token || null
        state.name = resp.name
        state.user = resp.user
        state.id = resp.id
        state.warehouse = resp.warehouse

        state.previous_name = resp.name
        state.previous_user = resp.user

        if (process.env.NODE_ENV === 'production')
            setUser({id: resp.user, username: resp.name})
    },
    auth_error(state) {
        state.status = 'error'
        state.name = ''
        state.id = ''
        state.user = ''

        if (process.env.NODE_ENV === 'production')
            setUser(null)
    },
    auth_logout(state) {
        state.status = 'logout'
        state.name = ''
        state.id = ''
        state.user = ''

        if (process.env.NODE_ENV === 'production')
            setUser(null)
    }
}

export default {
    state,
    actions,
    getters,
    mutations,
}